import { defineMessages } from "react-intl";

export const messages = defineMessages({
  discountCollectionsHeader: {
    id: "XNeJay",
    defaultMessage: "Eligible Collections",
    description: "section header",
  },
  discountCollectionsButton: {
    id: "/6uK4C",
    defaultMessage: "Assign collections",
    description: "button",
  },
  discountCollectionsTableProductHeader: {
    id: "ht9yOD",
    defaultMessage: "Collection Name",
    description: "table head",
  },
  discountCollectionsTableProductNumber: {
    id: "QGjJcT",
    defaultMessage: "Products",
    description: "number of products",
  },
  discountCollectionsNotFound: {
    id: "IoCMjg",
    defaultMessage: "No collections found",
    description: "no collections",
  },
});
